export const explainInvoice = context => ({
  schema: {
    explanation: {
      label: context.$t('actions.form.explanation.label'),
      placeholder: context.$t('actions.form.explanation.placeholder'),
      type: 'textarea',
      rows: 5,
      validation: 'required',
    }
  },
  formModel: {
    explanation: '',
  },
  layout: {
    'div.grid': {
      'div.grid.grid-cols-1': {
        div: {
          field: 'explanation',
        },
      },
      'div.grid.grid-cols-1:0': {
        div: {
          slot: 'additional-info-note',
        },
      },
    }
  },
});

export default explainInvoice;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-definition/explain-invoice.js